export const INVITATION = "Invitation";

export const ACCEPT_INVITATION = "AcceptInvitation";
